import { memo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { partnerEditorTranslation } from '../../translation'
import { PartnerSummury } from '../partnerSummury/PartnerSummury'

import { IPartnerFormTitleProps } from './models'

import styles from './PartnerFormTitle.module.scss'

export const PartnerFormTitle = memo<IPartnerFormTitleProps>(({ partner, title }) => {
  return (
    <div className={styles.partnerFormTitle}>
      <PartnerSummury partner={partner} />
      <div>
        <span className={styles.formType}>
          <Translation text={partnerEditorTranslation.header.partnerFormTitle.formType} span />
        </span>
        <h2 className={styles.title}>{title}</h2>
      </div>
    </div>
  )
})
